export default __webpack_public_path__ + "static/olivia-182af087b8062c3d745b440f9e71d21f.jpg";